/** @format */

import {useOptionallyControlledState} from '../hooks/use_optionally_controlled_state';
import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

export const Radio = forwardRef(
    ({label, value, checked, name, onChange, disabled, error, ...props}, ref) => {
        const hasError = !!error;

        return (
            <div className={`field ${hasError && 'field--error'}`}>
                <label className="font-body-md">
                    <input
                        className="control"
                        type="radio"
                        ref={ref}
                        name={name}
                        disabled={disabled}
                        value={value}
                        checked={checked}
                        onChange={() => onChange?.(value)}
                        {...props}
                    />
                    <span>{label}</span>
                </label>
                {hasError && <p className="color-alert-negative">{error}</p>}
            </div>
        );
    }
);

Radio.displayName = 'Radio';

Radio.propTypes = {
    checked: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.string
};

Radio.defaultProps = {
    label: 'Label Name',
    disabled: false,
    checked: false
};

export const RadioGroup = ({value: controlledValue, defaultState, onChange, name, children}) => {
    const [state, setState] = useOptionallyControlledState(controlledValue, defaultState, onChange);

    return (
        <>
            {React.Children.map(children, child => {
                return React.cloneElement(child, {
                    name: name,
                    checked: state.toString() === child.props.value.toString(),
                    onChange: v => setState(v)
                });
            })}
        </>
    );
};

RadioGroup.displayName = 'RadioGroup';

RadioGroup.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    defaultState: PropTypes.any,
    onChange: PropTypes.func,
    children: PropTypes.node
};

RadioGroup.defaultProps = {
    value: {}
};
